import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 0 14% 20px 14%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const BoldWrapper = styled.b`
  color: ${(p) => p.theme.colors.text};
`;

export const SubHeader = styled.div`
  ${(p) => p.theme.typography.description};
  color: ${(p) => p.theme.colors.muted};
  text-align: center;
`;
